import React, { useState } from 'react';
import { Button, Typography, Grid, Box, Backdrop, TextField } from '@mui/material'
import AppLoader from '../../../components/AppLoader/AppLoader';
import { Link } from 'react-router-dom';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import SearchIcon from '@mui/icons-material/Search';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import '../OrganizationManagement.scss'
import { useNavigate } from 'react-router-dom';
import { cfpBaseUrl } from '../../../network/urls';
import moment from 'moment/moment';
import CheckPermissions from '../../../authorization/authorization';
import { tableStyle } from '../../../style/common';
import { DataGrid } from '@mui/x-data-grid';
import { companyShortName, convertDate, convertDatewithTime } from '../../../services/Functions';
import BasicTable from '../../../components/basicTable/basicTable';
import { useSelector } from 'react-redux';
import PasswordRoundedIcon from '@mui/icons-material/PasswordRounded';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { Snackbar, Alert } from '@mui/material';
import Error from '../../../components/error/error';
export default function SubDivisionManagementTable(props) {
    //#region 
    const [subDivisionToDataGrid, setSubDivisionToDataGrid] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [open, setOpen] = useState(false);
    const [open2, setopen2] = useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [dltSubDivision, setDltSubDivision] = useState()
    const [tableSubDivision, setTableSubDivision] = useState([]);
    const [viewBackdrop, setViewBackdrop] = useState(true);
    const [tableDataLoaded, setTableDataLoaded] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
    const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
    const [apiError, setApiError] = useState('')
    const Navigate = useNavigate();

    const errorCloses = () => {
        setApiError("")
    };
    const { token, code: userOfficeCode, permissions } = useSelector((state) => state.auth)

    //#endregion
    useEffect(() => {
        if (!tableDataLoaded) return;
        apiToDataGridConversion();
        setViewBackdrop(false);
    }, [tableSubDivision, tableDataLoaded]);

    useEffect(() => {
        const callAllSubDivisionsAPI = async () => {
            setViewBackdrop(true);
            setTableDataLoaded(false);
            // const formdata = new FormData();

            // if (userOfficeCode == 10) {
            //     formdata.append("divisionCode", '');
            // } else {
            //     formdata.append("divisionCode", parseInt(userOfficeCode.toString().slice(0, 2)));
            // }

            // const myHeaders = new Headers();
            // myHeaders.append("Authorization", token);

            // const requestOptions = {
            //     method: "POST",
            //     body: formdata,
            //     headers: myHeaders,
            //     redirect: "follow"
            // };
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "divisionCode": userOfficeCode == 10 ? userOfficeCode : parseInt(userOfficeCode.toString().slice(0, 4)),
                "pageNumber": 1,
                "pageSize": 9999
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "customerFaciliationPortal/getSubDivisionDetails", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        setTableSubDivision(result.data);
                    } else if (result.status === "401" && result.message === "Session has been expired, Sign in again.") {
                        Navigate('/')
                        setTableSubDivision([]);
                    } else {
                        setTableSubDivision([]);
                    }
                })
                .catch(() => {
                    setTableSubDivision([]);
                });
            setTableDataLoaded(true);
        }
        callAllSubDivisionsAPI()
    }, [])

    const initialValues = {
        iv_subDivBankName: '',
        iv_subDivisionERPCode: '',
        iv_subDivCapitalCostAccountNo: '',
        iv_subDivSecurityAccountNo: '',
        iv_remarks: '',
    }
    const bankdetailsFormik = useFormik({
        initialValues,
        validationSchema: Yup.object({
            iv_subDivBankName: Yup.string()
                .max(100, 'Bank name cannot exceed 100 characters.')
                .min(10, 'Bank name must be at least 10 characters long.')
                .required('Bank name is required.'),

            iv_subDivisionERPCode: Yup.string()
                .required('ERP code is required.'),

            iv_subDivCapitalCostAccountNo: Yup.string()
                .min(10, 'Capital cost account no. must be at least 10 characters long.')
                .required('Capital cost account no. is required.'),

            iv_subDivSecurityAccountNo: Yup.string()
                .min(10, 'Security account no. must be at least 10 characters long.')
                .required('Security account no. is required.'),

            iv_remarks: Yup.string()
                .max(100, 'Remarks cannot exceed 100 characters.')
                .required('Remarks are required.')
        }),

        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "subDivisionCode": selectedUserId,
                "subDivisionERPCode": values.iv_subDivisionERPCode,
                "subDivBankName": values.iv_subDivBankName,
                "subDivCapitalCostAccountNo": values.iv_subDivCapitalCostAccountNo,
                "subDivSecurityAccountNo": values.iv_subDivSecurityAccountNo,
                "remarks": values.iv_remarks
            });

            const requestOptions = {
                method: "PUT",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "customerFaciliationPortal/updateSubDivisionBankDetails", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === "200") {
                        resetForm();
                        setShowChangePasswordPopup(false)
                        setShowSuccessSnackbar(true);
                        window.location.reload()
                        setTimeout(() => {
                            setShowChangePasswordPopup(false);
                        }, 300);
                    } else if (result.status === "400") {
                        setApiError(result.message)
                    }
                }
                )
                .catch(() => {});
            setViewBackdrop(false);
        },
    });
    const filterSubDivision = (subDivisionCode) => {
        let itemFound = tableSubDivision.find(item => item.subDivisionCode === subDivisionCode)
        return itemFound;
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setopen2(false);
    };

    const onDelete = async () => {
        setViewBackdrop(true)
        var formdata = new FormData();
        formdata.append("subDivisionCode", dltSubDivision);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "customerFaciliationPortal/deleteSubDivision", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    let myArray = [...tableSubDivision]
                    let index = myArray.findIndex(obj => obj.subDivisionCode === dltSubDivision);
                    if (index != -1) {
                        myArray.splice(index, 1);
                        setTableSubDivision(myArray)
                    }
                }
                else {
                }
            })
            .catch(() => {});
        handleClose2();
        setViewBackdrop(false)
    }
    const tblColumns = [
        { field: "id", headerName: 'Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "completename", headerName: 'SubDivision Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "companyname", headerName: 'Company Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        CheckPermissions(permissions, "Organization Management", "Sub Division Management", "Update Sub Div Bank Details") && {
            field: "button",
            headerName: "Bank Details",
            align: "center",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => (
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <IconButton aria-label="edit" size="small" sx={{ margin: 0.4, padding: 0 }}>
                        <EditNoteIcon
                            sx={{ color: "#e25316ff" }}
                            onClick={() => {
                                setSelectedUserId(params.id);
                                bankdetailsFormik.setValues({
                                    iv_subDivisionERPCode: params ? params.erp_code || "" : "",
                                    iv_subDivBankName: params ? params.bank_name || "" : "",
                                    iv_subDivCapitalCostAccountNo: params ? params.capital_code || "" : "",
                                    iv_subDivSecurityAccountNo: params ? params.security_code || "" : "",
                                    iv_remarks: "",
                                });

                                setShowChangePasswordPopup(true);
                            }}
                            alt="Bank Details"
                            style={{ width: "24px", height: "24px" }}
                        />
                    </IconButton>
                </div>
            ),
        },
        {
            headerName: "Action",
            sortable: false,
            field: 'buttons',
            align: 'center',
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            renderCell: (params) => {
                const onViewSubDivision = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    const item = filterSubDivision(params.id);
                    setDialogRowData(item);
                    setOpen(true);

                };
                const onDeleteSubDivision = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setopen2(true);
                    setDltSubDivision(params.id)
                }
                const onEditSubDivision = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    const subDivisionToEdit = filterSubDivision(params.id);
                    Navigate('/sub-division-management/update-sub-division', { state: { subDivisionToEdit } })
                }

                return (
                    <Box>
                        {CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Read') && (
                            <IconButton onClick={onViewSubDivision} size="small" sx={{ margin: 0.4, padding: 0 }}>
                                <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
                            </IconButton>
                        )}
                        {CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Update') && (
                            <IconButton onClick={onEditSubDivision} size="small" sx={{ margin: 0.4, padding: 0 }}>
                                <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
                            </IconButton>
                        )}
                        {CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Delete') && (
                            <IconButton onClick={onDeleteSubDivision} size="small" sx={{ margin: 0, padding: 0 }}>
                                <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
                            </IconButton>
                        )}
                    </Box>
                );
            }
        }
    ].filter(Boolean); // 🚀 removes the `false`

    // const tblColumns = [
    //     { field: "id", headerName: 'Code', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     { field: "completename", headerName: 'SubDivision Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     { field: "companyname", headerName: 'Company Name', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    //     CheckPermissions(permissions, "Organization Management", "Sub Division Management", "Update Sub Div Bank Details") && {
    //         field: "button",
    //         headerName: "Bank Details",
    //         align: "center",
    //         headerStyle: tableStyle.headerStyle,
    //         headerCellStyle: tableStyle.headerCellStyle,
    //         rowCellStyle: tableStyle.rowCellStyle,
    //         renderCell: (params) => {
    //             return (
    //                 <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
    //                     <IconButton
    //                         aria-label="edit"
    //                         size="small"
    //                         sx={{ margin: 0.4, padding: 0 }}
    //                     >
    //                         <EditNoteIcon
    //                             sx={{ color: "#e25316ff" }}
    //                             onClick={() => {
    //                                 setSelectedUserId(params.id);
    //                                 setShowChangePasswordPopup(true);
    //                             }}
    //                             alt="Bank Details"
    //                             style={{ width: "24px", height: "24px" }}
    //                         />
    //                     </IconButton>
    //                 </div>
    //             );
    //         },
    //     },
    //     {
    //         headerName: "Action",
    //         sortable: false,
    //         field: 'buttons',
    //         align: 'center',
    //         headerStyle: tableStyle.headerStyle,
    //         headerCellStyle: tableStyle.headerCellStyle,
    //         rowCellStyle: tableStyle.rowCellStyle,
    //         renderCell: (params) => {
    //             const onViewSubDivision = (e) => {
    //                 e.stopPropagation(); // don't select this row after clicking
    //                 const item = filterSubDivision(params.id);
    //                 setDialogRowData(item);
    //                 setOpen(true);

    //             };
    //             const onDeleteSubDivision = (e) => {
    //                 e.stopPropagation(); // don't select this row after clicking
    //                 setopen2(true);
    //                 setDltSubDivision(params.id)
    //             }
    //             const onEditSubDivision = (e) => {
    //                 e.stopPropagation(); // don't select this row after clicking
    //                 const subDivisionToEdit = filterSubDivision(params.id);
    //                 Navigate('/sub-division-management/update-sub-division', { state: { subDivisionToEdit } })
    //             }
    //             return (
    //                 <>
    //                     <Box>
    //                         <Box>
    //                             {
    //                                 CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Read') ?
    //                                     <IconButton onClick={onViewSubDivision} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
    //                                         <VisibilityIcon sx={{ color: 'skyblue' }} fontSize='inherit' />
    //                                     </IconButton> : null
    //                             }
    //                             {
    //                                 CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Update') ?
    //                                     <IconButton onClick={onEditSubDivision} aria-label="delete" size="small" sx={{ margin: 0.4, padding: 0 }}>
    //                                         <EditIcon fontSize="inherit" sx={{ color: 'blue' }} />
    //                                     </IconButton> : null
    //                             }
    //                             {
    //                                 CheckPermissions(permissions, 'Organization Management', 'Division Management', 'Delete') ?
    //                                     <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteSubDivision}>
    //                                         <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
    //                                     </IconButton> : null
    //                             }
    //                         </Box>
    //                     </Box>
    //                 </>
    //             )
    //         }
    //     }
    // ]

    const apiToDataGridConversion = () => {
        const myArray = tableSubDivision
        const tempArray = []
        if (myArray) {
            myArray.forEach((item) => {
                const slicedCircleCode = item.subDivisionCode.toString().slice(0, 2);

                const dataGridObject = {
                    "id": item.subDivisionCode,
                    "completename": item.subDivisionName ? item.subDivisionName : '-',
                    // "created_by": item.createdBy ? item.createdBy : '-',
                    // "created_at": item.createdDate ? convertDate(item.createdDate) : '-',
                    // "updated_by": item.updateBy ? item.updateBy : '-',
                    // "updated_at": item.updatedDate ? convertDate(item.updatedDate) : '-',
                    "companyname": companyShortName(slicedCircleCode),
                    // "circlecode": item.circleCode ,
                    // "divisioncode": item.divisionCode ? item.divisionCode : '_',
                    "bank_name": item.subDivBankName ? item.subDivBankName : '-',
                    "erp_code": item.subDivErpCode ? item.subDivErpCode : '-',
                    "capital_code": item.subDivCapitalCostAccountNo ? item.subDivCapitalCostAccountNo : '-',
                    "security_code": item.subDivSecurityAccountNo ? item.subDivSecurityAccountNo : '-'
                }
                tempArray.push(dataGridObject)
            })
        }
        else {
            const dataGridObject = {
                "id": " ",
                "completename": " ",
                "created_by": " ",
                "created_at": " ",
                "updated_by": " ",
                "updated_at": " ",
            }
            tempArray.push(dataGridObject)
        }
        setSubDivisionToDataGrid(tempArray);
        setFilteredData(tempArray); // keep a filtered copy
    }
    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchQuery(value);

        const filtered = subDivisionToDataGrid.filter((row) =>
            row.id.toString().toLowerCase().includes(value) ||
            row.companyname?.toLowerCase().includes(value) ||
            row.completename?.toLowerCase().includes(value)
        );

        setFilteredData(filtered);
    };

    return (

        <>
            <Box className='form-box org-management-list'>
                {/* <Box className='main-heading'>
                    <h2>
                        Sub Division Management
                    </h2>
                    <div className='btn2'>
                        {
                            CheckPermissions(permissions,'Organization Management', 'Sub Division Management', 'Create') &&
                            < Link to="/sub-division-management/new-sub-division">
                                <Button variant="contained" size='small' className='btnNewApplication' startIcon={<AddCircleIcon />} sx={{ textTransform: 'capitalize' }} >
                                    Create Sub Division
                                </Button>
                            </Link>
                        }
                    </div>
                </Box> */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <h3 className="page-title">Sub Division Management</h3>

                    <div
                        style={{
                            backgroundColor: "white",
                            display: "flex",
                            alignItems: "center",
                            borderRadius: "10px",
                            padding: "5px 10px",
                            border: "1px solid grey",
                            margin: "0px",
                        }}
                    >
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearch}
                            placeholder="Search by Code, SubDivision Name or Company Name"
                            maxLength={20}
                            style={{
                                flex: 1,
                                padding: "8px",
                                border: "none",
                                backgroundColor: "transparent",
                                outline: "none",
                                fontSize: "13px",
                                minWidth: "300px",
                            }}
                        />
                        <SearchIcon
                            sx={{
                                color: "#09669d",
                                width: 30,
                                height: 30,
                                borderRadius: "8px",
                                padding: "6px",
                                cursor: "pointer",
                                transition: "background-color 0.3s",
                                "&:hover": {
                                    color: "#074f7d",
                                },
                            }}
                        />
                    </div>
                </Box>



                <Box className='application-table'>
                    <BasicTable
                        data={filteredData}
                        columns={tblColumns}
                        sx={tableStyle}
                        rowHeight={37.5}
                        pageSize={18}
                        rowsPerPageOptions={[18, 30, 60]}
                        rowsPageOption={false}
                        getRowStyle={(params) => {
                            return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                        }} />
                </Box>
            </Box>

            {/* <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                // fullWidth={true}
                // maxWidth={'sm'}
                PaperProps={{ sx: { width: '30%' } }}
            >
                <DialogTitle id="alert-dialog-title" className="dialog-title">
                    <IconButton onClick={handleClose} sx={{ position: "relative", float: 'right' }}>
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ fontWeight: 'bold' }}>Sub Division Details</Typography>

                </DialogTitle>
                <DialogContent className='dialog-content'>
                    <DialogContentText id="alert-dialog-description">
                        <hr />
                        <Grid className='content-grid' sx={{ mt: '17px', display: 'flex', flexDirection: "column" }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>ID:</h5><span>{dialogRowData.subDivisionCode ? dialogRowData.subDivisionCode : '-'}</span>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Name:</h5><p>{dialogRowData.subDivisionName ? dialogRowData.subDivisionName : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Latitude:</h5><p>{dialogRowData.latitude ? dialogRowData.latitude : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Longitude:</h5><p>{dialogRowData.longitude ? dialogRowData.longitude : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>status:</h5><p>{(dialogRowData.status === '0' || dialogRowData.status === 'active') ? 'Active' : 'InActive'}</p>
                                </Box>

                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5>Is Store</h5><p>{(dialogRowData.isStore === '0' || dialogRowData.isStore === 'No') ? 'No' : 'Yes'}</p>
                                </Box>



                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Created by:</h5><p>{dialogRowData.createdBy ? dialogRowData.createdBy : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Created at:</h5><p>{dialogRowData.createdDate ? convertDatewithTime(dialogRowData.createdDate) : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Last Updated By:</h5><p>{dialogRowData.updateBy ? dialogRowData.updateBy : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Last Updated At:</h5><p>{dialogRowData.updatedDate ? convertDatewithTime(dialogRowData.updatedDate) : '-'}</p>
                                </Box>
                                <Box sx={{ marginTop: '35px' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>Contact Person 1</Typography>
                                </Box>
                                <hr />
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Name:</h5><p>{dialogRowData.cp1Name ? dialogRowData.cp1Name : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Phone:</h5><p>{dialogRowData.cp1phone ? dialogRowData.cp1phone : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Mobile:</h5><p>{dialogRowData.cp1Mobile ? dialogRowData.cp1Mobile : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Email:</h5><p>{dialogRowData.cp1Email ? dialogRowData.cp1Email : '-'}</p>
                                </Box>
                                <Box sx={{ marginTop: '35px' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>Contact Person 2</Typography>
                                </Box>
                                <hr />
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Name:</h5><p>{dialogRowData.cp2Name ? dialogRowData.cp2Name : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Phone:</h5><p>{dialogRowData.cp2phone ? dialogRowData.cp2phone : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Mobile:</h5><p>{dialogRowData.cp2Mobile ? dialogRowData.cp2Mobile : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Email:</h5><p>{dialogRowData.cp2Email ? dialogRowData.cp2Email : '-'}</p>
                                </Box>
                                <Box sx={{ marginTop: '35px' }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>Bank Details</Typography>
                                </Box>
                                <hr />
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Bank Name:</h5><p>{dialogRowData.subDivBankName ? dialogRowData.subDivBankName : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >ERP Code:</h5><p>{dialogRowData.subDivErpCode ? dialogRowData.subDivErpCode : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Capital Cost Account No.:</h5><p>{dialogRowData.subDivCapitalCostAccountNo ? dialogRowData.subDivCapitalCostAccountNo : '-'}</p>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between" }}>
                                    <h5 >Security Cost Account No.:</h5><p>{dialogRowData.subDivSecurityAccountNo ? dialogRowData.subDivSecurityAccountNo : '-'}</p>
                                </Box>
                            </Box>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog > */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                PaperProps={{ sx: { borderRadius: 3, maxWidth: 1000 } }}
                className="alert-popups"
            >
                <DialogTitle
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    className="dialog-title"
                >
                    Sub Division Details
                    <IconButton onClick={handleClose} sx={{ color: 'black' }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent className="dialog-content">
                    <DialogContentText sx={{ minHeight: 300 }}>
                        <Grid container spacing={2} sx={{ padding: '20px' }}>
                            {/* General Information */}
                            <Grid item xs={12}>
                                <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
                                    <h4 style={{ color: '#006ad1' }}>General Information</h4>
                                </Box>
                            </Grid>
                            {[
                                { label: 'ID', value: dialogRowData.subDivisionCode },
                                { label: 'Name', value: dialogRowData.subDivisionName },
                                { label: 'Latitude', value: dialogRowData.latitude },
                                { label: 'Longitude', value: dialogRowData.longitude },
                                {
                                    label: 'Status',
                                    value:
                                        dialogRowData.status === '0' || dialogRowData.status === 'active'
                                            ? 'Active'
                                            : 'Inactive',
                                },
                                {
                                    label: 'Is Store',
                                    value:
                                        dialogRowData.isStore === '0' || dialogRowData.isStore === 'No'
                                            ? 'No'
                                            : 'Yes',
                                },
                                { label: 'Created By', value: dialogRowData.createdBy },
                                { label: 'Created At', value: convertDatewithTime(dialogRowData.createdDate) },
                                { label: 'Last Updated By', value: dialogRowData.updateBy },
                                { label: 'Last Updated At', value: convertDatewithTime(dialogRowData.updatedDate) },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={index}>
                                    <label style={{ fontWeight: 600 }}>{item.label}</label>
                                    <TextField
                                        value={item.value || '-'}
                                        fullWidth
                                        disabled
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />
                                </Grid>
                            ))}

                            {/* Contact Person 1 */}
                            <Grid item xs={12} mt={3}>
                                <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
                                    <h4 style={{ color: '#006ad1' }}>Contact Person 1</h4>
                                </Box>
                            </Grid>
                            {[
                                { label: 'Name', value: dialogRowData.cp1Name },
                                { label: 'Phone', value: dialogRowData.cp1phone },
                                { label: 'Mobile', value: dialogRowData.cp1Mobile },
                                { label: 'Email', value: dialogRowData.cp1Email },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={`cp1-${index}`}>
                                    <label style={{ fontWeight: 600 }}>{item.label}</label>
                                    <TextField
                                        value={item.value || '-'}
                                        fullWidth
                                        disabled
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />
                                </Grid>
                            ))}

                            {/* Contact Person 2 */}
                            <Grid item xs={12} mt={3}>
                                <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
                                    <h4 style={{ color: '#006ad1' }}>Contact Person 2</h4>
                                </Box>
                            </Grid>
                            {[
                                { label: 'Name', value: dialogRowData.cp2Name },
                                { label: 'Phone', value: dialogRowData.cp2phone },
                                { label: 'Mobile', value: dialogRowData.cp2Mobile },
                                { label: 'Email', value: dialogRowData.cp2Email },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={`cp2-${index}`}>
                                    <label style={{ fontWeight: 600 }}>{item.label}</label>
                                    <TextField
                                        value={item.value || '-'}
                                        fullWidth
                                        disabled
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />
                                </Grid>
                            ))}

                            {/* Bank Details */}
                            <Grid item xs={12} mt={3}>
                                <Box sx={{ backgroundColor: '#d5e5ff', padding: '5px' }}>
                                    <h4 style={{ color: '#006ad1' }}>Bank Details</h4>
                                </Box>
                            </Grid>
                            {[
                                { label: 'Bank Name', value: dialogRowData.subDivBankName },
                                { label: 'ERP Code', value: dialogRowData.subDivErpCode },
                                { label: 'Capital Cost Account No.', value: dialogRowData.subDivCapitalCostAccountNo },
                                { label: 'Security Cost Account No.', value: dialogRowData.subDivSecurityAccountNo },
                            ].map((item, index) => (
                                <Grid item xs={12} sm={6} md={4} key={`bank-${index}`}>
                                    <label style={{ fontWeight: 600 }}>{item.label}</label>
                                    <TextField
                                        value={item.value || '-'}
                                        fullWidth
                                        disabled
                                        size="small"
                                        sx={{ mt: 0.5 }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog>

            < Dialog
                open={showChangePasswordPopup}
                onClose={() => (setShowChangePasswordPopup(false), setSelectedUserId(null), bankdetailsFormik.values.iv_subDivBankName = '', bankdetailsFormik.values.iv_subDivCapitalCostAccountNo = '', bankdetailsFormik.values.iv_remarks = '', bankdetailsFormik.values.iv_subDivSecurityAccountNo = '', bankdetailsFormik.values.iv_subDivisionERPCode = '')}
                fullWidth={true}
                maxWidth="xs"
                className='alert-popups' >
                <DialogTitle sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} className='dialog-title'>
                    SubDivision Bank Details
                    <Box sx={{ marginTop: '1%' }} >
                        <CloseIcon id="clearPopup" onClick={() => (setShowChangePasswordPopup(false), setSelectedUserId(null), bankdetailsFormik.values.iv_subDivBankName = '', bankdetailsFormik.values.iv_subDivCapitalCostAccountNo = '', bankdetailsFormik.values.iv_remarks = '', bankdetailsFormik.values.iv_subDivSecurityAccountNo = '', bankdetailsFormik.values.iv_subDivisionERPCode = '')} sx={{ color: 'white', cursor: 'pointer' }} />
                    </Box>
                </DialogTitle>
                <DialogContent className='dialog-content'>
                    <DialogContentText>
                        <form className='complaintform'>
                            <Grid container sx={{ padding: '20px' }}>
                                <Grid item lg={12} >
                                    <Grid container spacing={1}>
                                        <Grid item lg={12}>
                                            <Grid container spacing={1}>

                                                <Grid item lg={12}>
                                                    <label>SubDivision Code</label>
                                                    <TextField
                                                        sx={{
                                                            width: '100%',
                                                            '.MuiInputBase-input': {
                                                                height: '.5vh',
                                                            },
                                                        }}
                                                        required
                                                        type="text"
                                                        autoComplete="off"
                                                        name="iv_remarks"
                                                        value={selectedUserId}
                                                        disabled
                                                        id="iv_remarks"
                                                        className="textInputField"
                                                    />

                                                </Grid>
                                                <Grid item lg={12}>
                                                    <label>ERP Code</label>
                                                    <TextField
                                                        sx={{
                                                            width: '100%',
                                                            '.MuiInputBase-input': {
                                                                height: '.5vh',
                                                            },
                                                        }}
                                                        required
                                                        type="text"
                                                        autoComplete="off"
                                                        name="iv_subDivisionERPCode"
                                                        value={bankdetailsFormik.values.iv_subDivisionERPCode}
                                                        onChange={bankdetailsFormik.handleChange}
                                                        onBlur={bankdetailsFormik.handleBlur}
                                                        id="iv_subDivisionERPCode"
                                                        className="textInputField"
                                                    />
                                                    <Grid>
                                                        {
                                                            bankdetailsFormik.errors.iv_subDivisionERPCode && bankdetailsFormik.touched.iv_subDivisionERPCode ? (
                                                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{bankdetailsFormik.errors.iv_subDivisionERPCode}</p>
                                                            ) : null
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid item lg={12}>
                                                    <label>Bank Name</label>
                                                    <TextField
                                                        sx={{
                                                            width: '100%',
                                                            '.MuiInputBase-input': {
                                                                height: '.5vh',
                                                            },
                                                        }}
                                                        required
                                                        type="text"
                                                        autoComplete="off"
                                                        name="iv_subDivBankName"
                                                        value={bankdetailsFormik.values.iv_subDivBankName}
                                                        onChange={bankdetailsFormik.handleChange}
                                                        onBlur={bankdetailsFormik.handleBlur}
                                                        id="iv_subDivBankName"
                                                        className="textInputField"
                                                    />
                                                    <Grid>
                                                        {
                                                            bankdetailsFormik.errors.iv_subDivBankName && bankdetailsFormik.touched.iv_subDivBankName ? (
                                                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{bankdetailsFormik.errors.iv_subDivBankName}</p>
                                                            ) : null
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid item lg={12}>
                                                    <label>Capital Cost Account No.</label>
                                                    <TextField
                                                        sx={{
                                                            width: '100%',
                                                            '.MuiInputBase-input': {
                                                                height: '.5vh',
                                                            },
                                                        }}
                                                        required
                                                        type="text"
                                                        autoComplete="off"
                                                        name="iv_subDivCapitalCostAccountNo"
                                                        value={bankdetailsFormik.values.iv_subDivCapitalCostAccountNo}
                                                        onChange={bankdetailsFormik.handleChange}
                                                        onBlur={bankdetailsFormik.handleBlur}
                                                        id="iv_subDivCapitalCostAccountNo"
                                                        className="textInputField"
                                                    />
                                                    <Grid>
                                                        {
                                                            bankdetailsFormik.errors.iv_subDivCapitalCostAccountNo && bankdetailsFormik.touched.iv_subDivCapitalCostAccountNo ? (
                                                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{bankdetailsFormik.errors.iv_subDivCapitalCostAccountNo}</p>
                                                            ) : null
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid item lg={12}>
                                                    <label>Security Account No</label>
                                                    <TextField
                                                        sx={{
                                                            width: '100%',
                                                            '.MuiInputBase-input': {
                                                                height: '.5vh',
                                                            },
                                                        }}
                                                        required
                                                        type="text"
                                                        autoComplete="off"
                                                        name="iv_subDivSecurityAccountNo"
                                                        value={bankdetailsFormik.values.iv_subDivSecurityAccountNo}
                                                        onChange={bankdetailsFormik.handleChange}
                                                        onBlur={bankdetailsFormik.handleBlur}
                                                        id="iv_subDivSecurityAccountNo"
                                                        className="textInputField"
                                                    />
                                                    <Grid>
                                                        {
                                                            bankdetailsFormik.errors.iv_subDivSecurityAccountNo && bankdetailsFormik.touched.iv_subDivSecurityAccountNo ? (
                                                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{bankdetailsFormik.errors.iv_subDivSecurityAccountNo}</p>
                                                            ) : null
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid item lg={12}>
                                                    <label>Remarks</label>
                                                    <TextField
                                                        sx={{
                                                            width: '100%',
                                                            '.MuiInputBase-input': {
                                                                height: '.5vh',
                                                            },
                                                        }}
                                                        required
                                                        type="text"
                                                        autoComplete="off"
                                                        name="iv_remarks"
                                                        value={bankdetailsFormik.values.iv_remarks}
                                                        onChange={bankdetailsFormik.handleChange}
                                                        onBlur={bankdetailsFormik.handleBlur}
                                                        id="iv_remarks"
                                                        className="textInputField"
                                                    />
                                                    <Grid>
                                                        {
                                                            bankdetailsFormik.errors.iv_remarks && bankdetailsFormik.touched.iv_remarks ? (
                                                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{bankdetailsFormik.errors.iv_remarks}</p>
                                                            ) : null
                                                        }
                                                    </Grid>
                                                </Grid>

                                                <Grid item lg={12} >
                                                    {
                                                        apiError &&
                                                        <Error
                                                            error={apiError}
                                                            onClose={() => errorCloses()}
                                                            backgroundColor="#FFC0CB"
                                                            textColor="#bb0303"
                                                            iconColor="#bb0303"
                                                        />
                                                    }
                                                </Grid>
                                                <Grid item lg={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <Button sx={{ width: '30%' }} variant="contained" size="medium" onClick={bankdetailsFormik.handleSubmit}>
                                                        Submit
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContentText>
                </DialogContent>
            </Dialog >
            <Snackbar
                open={showSuccessSnackbar}
                autoHideDuration={3000}
                onClose={() => setShowSuccessSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                sx={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                }}
            >
                <Alert
                    onClose={() => setShowSuccessSnackbar(false)}
                    severity="success"
                    sx={{ width: '100%' }}
                >
                    Bank Details Saved.
                </Alert>
            </Snackbar>
            <Dialog
                open={open2}
                onClose={handleClose2}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {" Are you sure to delete this record"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose2}>Cancel</Button>
                    <Button onClick={onDelete} autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >

        </>
    )
}
